import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import './about.scss'
import Footer from '../../components/Footer/Footer'

const About = () => {

    useEffect(() => {
        document.title = 'About FlashRoom'
    }, [])

    const [nav, openNav] = useState(false);


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    return (
        <div id='about-page'>

            <div className='nav-wrapper'>
                <div className='nav-2'>

                    <div className='nav-logo-container'>
                        <img src='images/flashroom-logo-light.png' height="44px" />
                        <h1>Flash<span>Room</span></h1>
                    </div>

                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>
            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>

            <div className="about-content">
                <div className="about-card">
                    <h1>About FlashRoom</h1>

                    <p className="tagline">
                        Share. Collaborate. Teach. Faster.
                    </p>

                    <p>
                        FlashRoom is a lightweight collaboration workspace designed to make sharing code,
                        files, and ideas instant without requiring account setup or annoying configuration.
                    </p>

                    <p>
                        It was built with educators, students, and small teams in mind: people who want to
                        get straight to the work instead of fighting interfaces or managing permissions.
                    </p>

                    {/* <div className="callout">
                        <h3>Why FlashRoom?</h3>
                        <p>
                            In many classrooms and collaborative environments, sharing starter code,
                            lesson materials, or project files still involves long links, emails,
                            logins, or screen sharing. FlashRoom removes those barriers.
                        </p>
                    </div> */}

                    <h2>How it works</h2>
                    <ul>
                        <li>Create a room</li>
                        <li>Invite others to join by entering in the code</li>
                        <li>Share code snippets, files, and folders in one workspace</li>
                        <li>Control who can view or edit content</li>
                    </ul>

                    {/* <h2>Designed for real workflows</h2>
                    <p>
                        FlashRoom is especially useful for:
                    </p>
                    <ul>
                        <li>Teachers sharing starter code, examples, or resources</li>
                        <li>Students collaborating on assignments or projects</li>
                        <li>Workshops, labs, and live coding sessions</li>
                        <li>Quick collaboration without long-term account setup</li>
                    </ul> */}

                    {/* <h2>Early access</h2>
                    <p>
                        FlashRoom is currently in beta. That means features are evolving, performance
                        is improving, and feedback actively shapes the product. If something feels
                        off or missing, that’s part of the process — and we want to hear about it.
                    </p>

                    <h2>Built with intention</h2>
                    <p>
                        The goal of FlashRoom isn’t to replace full learning platforms or heavy
                        collaboration suites. It’s to do one thing extremely well:
                        <strong> make sharing and collaborating fast, simple, and distraction-free.</strong>
                    </p> */}

                    <div className="divider" />



                    <h2>Why Use FlashRoom?</h2>

                    <p>
                        FlashRoom is simple by design, but flexible enough to support a wide range of classroom, collaboration, and personal uses.
                    </p>

                    <p className='use'>Classroom Use</p>
                    <p className='use-explaination'>
                        FlashRoom was originally built to make classroom file sharing faster and easier. While some web apps allow users to copy and share text, they often do not support complete files or folders. With FlashRoom, teachers can create a room and distribute materials to a few students or several hundred in under 30 seconds. This includes code, links, images, pdf's, power point, spread sheets, videos, audio, folders, and virtually any file format.
                    </p>

                    <p className='use'>Collaboration</p>
                    <p className='use-explaination'>
                        FlashRoom gives students a quick and accessible way to work together. Most major programming languages and text-based file formats can be created, uploaded, and edited directly within a room. Changes are broadcast in real time, and newly uploaded files appear immediately for everyone in the room. For younger students in coding classes or summer camps, configuring tools such as Git can be unnecessarily complicated for a short group project. FlashRoom allows students to begin collaborating in under 30 seconds without that extra setup. Although it was originally designed for coding projects, FlashRoom can also support a wide range of multimedia and group-based work.

                    </p>

                    <p className='use'>Personal Use</p>
                    <p className='use-explaination'>
                        FlashRoom can also serve as a convenient personal workspace. Quickly create notes that you can access from another computer, or transfer files such as PDFs between your school laptop, home desktop, or other devices.
                    </p>


                </div>
            </div>

            <Footer />
        </div>
    )
}

export default About
